/*
 * @Author: mayanxia 
 * @Date: 2022-01-19 14:33:49 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-01-06 16:00:00
 */


<!-- 调价记录 -->
<template>
    <div class="card-container">
        <a-tabs v-model="activeKey" class="new-tabs">
            <a-tab-pane :key="1" :tab="$t('调价详情列表')">
                <a-row :gutter="24" class="new-row">
                    <a-col :md="collapsed? 0: 5" :sm="24" class="new-col">
                        <a-card :bordered="false" class="new-tree-card">
                            <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
                            <a-alert type="info" :showIcon="true">
                                <div slot="message">
                                {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
                                <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
                                </div>
                            </a-alert>
                            <div style="display: flex;margin-top: 10px;">
                              <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
                              <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
                            </div>
                            <!-- 树-->
                            <a-col :md="24" :sm="24" class="new-tree-col">
                                <template>
                                <a-spin tip="Loading..." :spinning="areaLoading">
                                  <!--
                                    <span style="user-select: none">
                                    <a-tree
                                        class="my-area-select-tree"
                                        @select="onSelect"     
                                        :selectedKeys="selectedKeys"
                                        :treeData="areaTree"
                                        :checkStrictly="checkStrictly"
                                        :expandedKeys="iExpandedKeys"
                                        :autoExpandParent="autoExpandParent"
                                        @expand="onExpand">
                                        <template slot="title" slot-scope="{title}">
                                        <span v-if="title.indexOf(searchAreaValue) > -1">
                                            {{title.substr(0, title.indexOf(searchAreaValue))}}
                                        <span style="color: #32CD32">{{searchAreaValue}}</span>
                                            {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                                        </span>
                                        <span v-else>{{title}}</span>
                                        </template>
                                    </a-tree>
                                    </span>
                                    -->
                                    <el-tree
                                      class="filter-tree"
                                      :data="areaTree"
                                      :props="defaultProps"
                                      :expand-on-click-node="false"
                                      :filter-node-method="filterNode"
                                      :check-on-click-node="true"
                                      :check-strictly="checkStrictly"
                                      :highlight-current="true"
                                      node-key="id"
                                      :current-node-key="currentNodeKey"
                                      :default-expanded-keys="iExpandedKeys"
                                      @node-click="nodeClick"
                                      ref="areaTree">
                                    </el-tree>
                                </a-spin>
                                </template>
                            </a-col>
                            </div>
                        </a-card>
                    </a-col>
                    <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
                        <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
                        @click="collapsed = !collapsed"
                        class="area-collapsed"></a-icon>
                        <a-card :bordered="false" class="new-table-card">
                            <!-- 查询区域 -->
                            <div class="table-page-search-wrapper">
                            <a-form layout="inline" @keyup.enter.native="searchQuery">
                                <a-row :gutter="24">
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('表编号')">
                                    <j-input :placeholder="$t('表编号模糊查询')" v-model="queryParam.meterId"></j-input>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('用户编号')">
                                    <j-input :placeholder="$t('用户编号模糊查询')" v-model="queryParam.userId"></j-input>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                  <a-form-item :label="$t('用户姓名')">
                                    <j-input :placeholder="$t('用户姓名模糊查询')" v-model="queryParam.userName"></j-input>
                                  </a-form-item>
                                </a-col>
                                <template v-if="toggleSearchStatus">
                                  <a-col :xl="12" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('创建时间')">
                                        <a-range-picker
                                        v-model="date"
                                        format="YYYY-MM-DD"
                                        :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                                        @change="onDateRangeChange"
                                        @ok="onOk"
                                        />
                                      </a-form-item>
                                    </a-col>
                                    <a-col :xl="12" :lg="7" :md="8" :sm="24">
                                      <a-form-item :label="$t('新价格启用时间')">
                                          <a-range-picker
                                          v-model="startDate"
                                          format="YYYY-MM-DD"
                                          :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                                          @change="onStartDateRangeChange"
                                          @ok="onOk"
                                          />
                                      </a-form-item>
                                    </a-col>
                                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                      <a-form-item :label="$t('新价格名称')">
                                        <a-select :show-search="true" option-filter-prop="children" v-model="queryParam.userPriceIdNew" :placeholder="$t('请选择新价格名称')">
                                          <a-select-option v-for="data in userPriceList" :key="data.id" :value="data.id">
                                            {{data.wtName}}
                                          </a-select-option>
                                        </a-select>
                                      </a-form-item>
                                    </a-col>
                                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                      <a-form-item :label="$t('旧价格名称')">
                                        <a-select :showSearch="true" option-filter-prop="children" v-model="queryParam.userPriceId" :placeholder="$t('请选择旧价格名称')">
                                          <a-select-option v-for="data in userPriceList" :key="data.id" :value="data.id">
                                            {{data.wtName}}
                                          </a-select-option>
                                        </a-select>
                                      </a-form-item>
                                    </a-col>
                                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                      <a-form-item :label="$t('变更方式')">
                                        <a-select v-model="queryParam.changeWay" :placeholder="$t('请选择变更方式')" @change="$forceUpdate()">
                                          <a-select-option :value="1">
                                            {{ $t('立即结算') }}
                                          </a-select-option>
                                          <a-select-option :value="2">
                                            {{ $t('扣完再启用新价格') }}
                                          </a-select-option>
                                        </a-select>
                                      </a-form-item>
                                    </a-col>
                                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                      <a-form-item :label="$t('变更状态')">
                                        <a-select v-model="queryParam.successFlag" :placeholder="$t('请选择变更状态')" @change="$forceUpdate()">
                                          <a-select-option :value="0">
                                            {{ $t('待变更') }}
                                          </a-select-option>
                                          <a-select-option :value="2">
                                            {{ $t('变更中') }}
                                          </a-select-option>
                                          <a-select-option :value="1">
                                            {{ $t('变更成功') }}
                                          </a-select-option>
                                        </a-select>
                                      </a-form-item>
                                    </a-col>
                                </template>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                                    <a @click="handleToggleSearch" style="margin-left: 8px">
                                        {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                                        <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                                    </a>
                                    </span>
                                </a-col>
                                </a-row>
                            </a-form>
                            </div>
                            <!-- 操作按钮区域 -->
                            <div class="table-operator">
                            <a-button type="primary" icon="download" @click="handleExportXls($t('调价记录'))">{{ $t('导出') }}</a-button>
                            <a-button @click="handleBatchAdjustPrice()" type="primary" icon="shake" v-has="'meteruser:batchchangeprice'">{{ $t('批量调价') }}</a-button>
                            <a-dropdown v-if="selectedRowKeys.length > 0">
                                <a-menu slot="overlay">
                                <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
                                </a-menu>
                                <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
                            </a-dropdown>
                            </div>
                            <!-- table区域-begin -->
                            <div class="table-fixed">
                            <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
                                <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
                                <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
                                <span style="float:right;">
                                <a @click="loadData()"><a-icon type="sync" />{{ $t('刷新') }}</a>
                                <a-popover :title="$t('自定义列')" trigger="click" placement="leftBottom">
                                    <template slot="content">
                                    <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                                        <a-row>
                                        <template v-for="item in defColumns">
                                            <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                                                <a-col :span="12" :key="item.key"><a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox></a-col>
                                            </template>
                                        </template>
                                        </a-row>
                                    </a-checkbox-group>
                                    </template>
                                </a-popover>
                                </span>
                            </div>
                            <a-table
                                ref="table"
                                size="middle"
                                :scroll="{x:true}"
                                bordered
                                rowKey="id"
                                :columns="columns"
                                :dataSource="dataSource"
                                :pagination="ipagination"
                                :loading="loading"
                                class="j-table-force-nowrap"
                                @change="handleTableChange">
                                <div slot="filterDropdown">
                                <a-card>
                                    <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                                    <a-row>
                                        <template v-for="item in defColumns">
                                        <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                                            <a-col :span="12" :key="item.key">
                                            <a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox>
                                            </a-col>
                                        </template>
                                        </template>
                                    </a-row>
                                    </a-checkbox-group>
                                </a-card>
                                </div>
                                <span slot="newPriceSlot" slot-scope="text, record">
                                <span v-if="record.newPriceWtName"> {{record.newPriceWtName}}({{record.newPriceWtTotalPrice?record.newPriceWtTotalPrice + $t('元'): '--'}})</span>
                                <span v-else>--</span>
                                </span>
                                <span slot="oldPriceSlot" slot-scope="text, record">
                                <span v-if="record.oldPriceWtName"> {{record.oldPriceWtName}}({{record.oldPriceWtTotalPrice?record.oldPriceWtTotalPrice + $t('元'): '--'}})</span>
                                <span v-else>--</span>
                                </span>
                                <a-icon slot="filterIcon" type='down' :style="{ fontSize:'12px',color: '#108ee9'}" />
                                <template slot="htmlSlot" slot-scope="text">
                                <div v-html="text"></div>
                                </template>
                                <template slot="imgSlot" slot-scope="text">
                                <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
                                <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
                                </template>
                                <template slot="fileSlot" slot-scope="text">
                                <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
                                <a-button
                                    v-else
                                    :ghost="true"
                                    type="primary"
                                    icon="download"
                                    size="small"
                                    @click="downloadFile(text)">
                                    {{ $t('下载') }}
                                </a-button>
                                </template>
                                <span slot="successFlagSlot" slot-scope="text, record">
                                  <label v-if="record.successFlag === 2" class="doing-status">{{ $t('变更中') }}</label>
                                  <label v-else-if="record.successFlag === 1" class="finish-status">{{ $t('变更成功') }}</label>
                                  <label v-else class="wait-status">{{ $t('待变更') }}</label>
                                </span>
                                <span slot="action" slot-scope="text, record">
                                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
                                </span>
                            </a-table>
                            </div>
                            <meter-userinfo-transfer-record-modal ref="modalForm" @ok="modalFormOk"></meter-userinfo-transfer-record-modal>
                        </a-card>
                    </a-col>
                </a-row>
            </a-tab-pane>
            <a-tab-pane :key="2" :tab="$t('调价任务列表')" class="new-tab-pane-block">
                <meter-the-batch-tash-comp :taskType="8" :isCanCreate="false"></meter-the-batch-tash-comp>
            </a-tab-pane>
        </a-tabs>
        <meter-user-batch-adjust-price-modal ref="meterUserBatchAdjustPriceModal" @ok="modalFormOk"></meter-user-batch-adjust-price-modal>
    </div>
</template>

<script>

  import { getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import configService from '@/utils/service/config.service'
  import MeterUserinfoTransferRecordModal from './modules/MeterUserinfoTransferRecordModal'
  import MeterUserBatchAdjustPriceModal from '../meterManagement/modules/MeterUserBatchAdjustPriceModal'
  import meterTheBatchTashComp from '@/views/meterManagement/meterTheBatchTashComp'
  import moment from 'moment'
  import {isUndefined} from'@/utils/validate'
  import { listSize } from '@/utils/util'
  import Vue from 'vue'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'MeterUserinfoAdustPriceRecordList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin],
    components: {
      MeterUserinfoTransferRecordModal,
      meterTheBatchTashComp,
      MeterUserBatchAdjustPriceModal,
      JInput
    },
    data () {
      return {
        description: 'meter_userinfo_adjust_price_record管理页面',
        collapsed: false,
        //表头
        columns:[],
        //列设置
        settingColumns:[],
        url: {
          list: "/jeecg-charge/meter/meterPriceChangeRecord/list",
          delete: "/jeecg-charge/meter/meterPriceChangeRecord/delete",
          deleteBatch: "/jeecg-charge/meter/meterPriceChangeRecord/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterPriceChangeRecord/exportXls", //导出接口
          importExcelUrl: "jeecg-charge/meter/meterPriceChangeRecord/importExcel",
          userPriceCode: "/jeecg-charge/meter/meterPriceinfo/list",
        },
        beginDate: null,
        endDate: null,
        endOpen: false,
        date:[],
        startDate: [],
        dateType: 2,
        activeKey: 1,
        userPriceList: []
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.initColumns();
      this.queryUserPriceCode();
    },
    computed: {
      importExcelUrl: function(){
        return `${configService.apiUrl}/${this.url.importExcelUrl}`;
      },
      // i18n：列定义使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            }
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex:'userName',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex:'userAddr',
            width:150,
            ellipsis: true,
            customRender: (t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          },{
            title: this.$t('新价格信息'),
            align:"center",
            dataIndex: 'newPrice',
            width:150,
            ellipsis: true,
            scopedSlots: { customRender: 'newPriceSlot' },
          },{
            title: this.$t('旧价格信息'),
            align:"center",
            dataIndex: 'oldPrice',
            width:150,
            ellipsis: true,
            scopedSlots: { customRender: 'oldPriceSlot' },
          },{
            title: this.$t('新价格启用日期'),
            align:"center",
            dataIndex: 'startDate',
            width:150,
            ellipsis: true
          },{
            title: this.$t('变更方式'),
            align:"center",
            dataIndex: 'changeWay',
            customRender: (t,r,index) => {
                let obj = {1: this.$t('立即结算'), 2: this.$t('扣完再启用新价格')}
                if(!isUndefined(obj[t])) {
                    return obj[t]
                }
                return this.$t("未知");
            },
            width:150,
            ellipsis: true
          },{
            title: this.$t('变更状态'),
            align:"center",
            dataIndex: 'successFlag',
            scopedSlots: { customRender: 'successFlagSlot' },
            width:150,
            ellipsis: true
          },{
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime',
            width:150,
            ellipsis: true
          },{
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy',
            width:150,
            ellipsis: true
          }/*,
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:100,
            scopedSlots: { customRender: 'action' }
          }*/
        ]
      },
    },
    methods: {
      onOk(value) {
        console.log('onOk: ', value);
      },
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      handleBatchAdjustPrice() {
        this.$refs.meterUserBatchAdjustPriceModal.add()
        this.$refs.meterUserBatchAdjustPriceModal.title = this.$t('批量调价')
      },
      onStartDateRangeChange(value, dateStrings) {
        if(dateStrings[0]!=''&&dateStrings[1]!='') {
          if(this.dateType == 1) {
            this.queryParam.startDate = dateStrings[0]+' 00:00:00';
            this.queryParam.finishDate = dateStrings[1]+' 23:59:59';
          }else{
            this.queryParam.startDate = dateStrings[0];
            this.queryParam.finishDate = dateStrings[1];
          }
        }else{
          if(this.queryParam['startDate']) {
            delete this.queryParam['startDate']
          }
          if(this.queryParam['finishDate']) {
            delete this.queryParam['finishDate']
          }
        }
      },
      queryUserPriceCode() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userPriceCode, params).then((res) => {
          if(res.success){
            this.userPriceList = res.result.records;
          }
        }) 
      },
      searchReset() {
        this.queryParam = {}
        this.resetAareaData()
        this.date = []
        this.startDate = []
        this.loadData(1);
      },
    }
  }
</script>
<style scoped>
  .card-container {
  overflow: hidden;
  height: 100%;
}
.card-container /deep/ .ant-tabs-content {
  margin-top: -16px;
}
.card-container /deep/ .ant-tabs-bar {
  background-color: #fff;
}

.card-container /deep/  .ant-tabs-content  .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container /deep/  .ant-tabs-bar {
}

.card-container /deep/  .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container /deep/ .ant-tabs-bar .ant-tabs-tab-active {
  background: #fff;
}
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>